import Modal from 'bootstrap/js/dist/modal';
import { FeedbackRating } from '../commands/sendFeedback/feedbackDto';
import { ContactDetailsInput, ContactSettings, initContactSection, readContactSection, renderContactSection } from './contactDetails';

const CONTACT_PREFIX = 'feedback';

export interface FeedbackDialogOptions {
    /** When false, thumbs up/down is hidden and the point is saved as neutral. */
    allowRating: boolean;
    /** Optional contact fields - null when the dialog does not collect contact details. */
    contact?: ContactSettings | null;
}

export interface FeedbackDialogResult {
    rating: FeedbackRating;
    comment: string;
    save: boolean;
    contact?: ContactDetailsInput;
}

export async function showFeedbackDialog(options: FeedbackDialogOptions = { allowRating: true }): Promise<FeedbackDialogResult | null> {
    return new Promise((resolve) => {
        let completed = false;

        const modalEl = document.getElementById('feedbackModal')!;
        const commentEl = document.getElementById('feedbackComment') as HTMLTextAreaElement;
        const saveBtn = document.getElementById('saveFeedback')!;
        const validationEl = document.getElementById('feedbackValidation')!;
        const ratingSection = document.getElementById('feedbackRatingSection');
        const contactContainer = document.getElementById('feedbackContactContainer');

        const modal = new Modal(modalEl);

        // Reset
        commentEl.value = '';
        document.querySelectorAll<HTMLInputElement>('input[name="rating"]').forEach(r => r.checked = false);
        validationEl.classList.add('d-none');
        validationEl.textContent = '';

        // Hide the rating choice when the dialog uses neutral points
        ratingSection?.classList.toggle('d-none', !options.allowRating);

        // Rendered on every open so the contact section always starts empty
        if (contactContainer) {
            contactContainer.innerHTML = options.contact ? renderContactSection(options.contact, CONTACT_PREFIX) : '';
            if (options.contact) initContactSection(CONTACT_PREFIX);
        }

        const onSave = () => {
            const comment = commentEl.value.trim();
            const selected = options.allowRating
                ? document.querySelector<HTMLInputElement>('input[name="rating"]:checked')?.value as FeedbackRating | undefined
                : 'neutral';

            let error = '';
            if (!selected) {
                error = 'Du måste välja betyg (👍 eller 👎).';
            } else if (comment.length < 10) {
                error = 'Kommentaren måste vara minst 10 tecken.';
            }

            const contactResult = options.contact ? readContactSection(CONTACT_PREFIX) : {};
            if (!error && contactResult.error) {
                error = contactResult.error;
            }
            if (error) {
                validationEl.textContent = error;
                validationEl.classList.remove('d-none');
                return;
            }
            validationEl.classList.add('d-none');
            completed = true;
            modal.hide();
            resolve({
                rating: selected!,
                comment,
                save: true,
                contact: contactResult.contact
            });
        };

        const onHidden = () => {
            if (!completed) resolve(null);
            saveBtn.removeEventListener('click', onSave);
            modalEl.removeEventListener('hidden.bs.modal', onHidden as any);
        };

        saveBtn.addEventListener('click', onSave);
        modalEl.addEventListener('hidden.bs.modal', onHidden, { once: true });

        modal.show();

    });
}
